import { Trans } from 'react-i18next';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { Alert } from '@components/Alert';
import { formatLocaleDateAtTime } from '@helpers/dateHelpers';
import { CompetitionSessionNotHeldNotificationData } from './interfaces';

const isCompetitionSessionNotHeldPayload = (
  payload: unknown
): payload is CompetitionSessionNotHeldNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'competitionName' in payload &&
    typeof payload.competitionName === 'string' &&
    'reason' in payload &&
    typeof payload.reason === 'string'
  );
};

export const competitionSessionNotHeldPresenter: NotificationPresenter<CompetitionSessionNotHeldNotificationData> =
  {
    type: 'competition-session-not-held',
    icon: EmojiEventsIcon,
    badgeIcon: EventBusyIcon,
    isPayload: isCompetitionSessionNotHeldPayload,
    label: (payload, t) =>
      t('notifications:types.competition-session-not-held', {
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.competition-session-not-held"
        values={{
          competitionName: payload.competitionName,
          sessionHeldOn: formatLocaleDateAtTime(payload.sessionHeldOn),
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    body: (payload) => {
      const reason = payload.reason?.trim();

      if (!reason) {
        return null;
      }

      return <Alert severity="warning" content={reason} />;
    },
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return `${ROUTES.manage.competitions.details(payload.competitionSlug)}?tab=sessions`;
    },
  };
